import { toast } from "react-toastify";

const info = data => {
	return toast.info ( data );
};

const error = data => {
	return toast.error ( data );
};

const warn = data => {
	return toast.warning ( data );
};

const success = data => {
	return toast.success ( data );
};

export default {
	info,
	error,
	warn,
	success
};
